export default "__VITE_ASSET__La5IAMBH__"